import { Visibility } from "@mui/icons-material";
import { FormControl, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";

const AddRegisterAccount = ({ formik }) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  return (
    <div>
      <p className=" font-semibold text-[14px]">Registrasi Akun</p>
      <p className="mb-4">
        Silahkan input email dan password akun anda dibawah ini
      </p>

      <FormControl fullWidth sx={{ marginBottom: 2 }}>
        <TextField
          value={formik.values.owner.email}
          fullWidth
          placeholder="example@gmail.com"
          disabled
        />
      </FormControl>

      <FormControl fullWidth sx={{ marginBottom: 2 }}>
        <TextField
          value={formik.values.password}
          onChange={(e) => formik.setFieldValue("password", e.target.value)}
          fullWidth
          type={passwordVisibility ? "password" : "text"}
          placeholder="Password anda"
          helperText="Password harus terdiri atas min. 8 karakter, 1 huruf kapital, 1 huruf kecil, 1 angka, dan 1 karakter spesial"
          InputProps={{
            endAdornment: (
              <button
                type="button"
                className="hover:text-gray-400"
                onClick={() => setPasswordVisibility(!passwordVisibility)}
              >
                <InputAdornment position="end">
                  {passwordVisibility ? <Visibility /> : <Visibility />}
                </InputAdornment>
              </button>
            ),
          }}
        />
      </FormControl>
    </div>
  );
};

export default AddRegisterAccount;
